module.exports = __webpack_public_path__ + "static/media/sweet_1_tablet.af12a486.png";